<template>
  <v-row>
    <v-col cols="12" style="position: relative;">
      <v-tabs>
        <v-tab exact :to="{ name: 'system-admin-affiliates-edit' }">Details</v-tab>
        <v-tab exact :to="{ name: 'system-admin-affiliates-commissions' }">Commissions</v-tab>
      </v-tabs>

      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="error"
          @click="closeCreate"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>

        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular
            :size="40"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-card-text v-else>
          <h3 class="title" v-if="affiliateId">
            Affiliate page for {{ form.data.name }}
          </h3>
          <h3 v-else>Create new affiliate</h3>

          <v-form v-model="form.valid" ref="form" :disabled="form.disabled" lazy-validation>
            <v-row >
              <!-- Left column -->
              <v-col :cols="leftColumnWidth">
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      label="Name"
                      v-model="form.data.name"
                      :rules="form.rules.name"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="First Name"
                      v-model="form.data.first_name"
                      :rules="form.rules.first_name"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Last Name"
                      v-model="form.data.last_name"
                      :rules="form.rules.last_name"
                      outlined
                      hide-details="auto"
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Company"
                      v-model="form.data.company"
                      :rules="form.rules.company"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Address 1"
                      v-model="form.data.address_1"
                      :rules="form.rules.address_1"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Address 2"
                      v-model="form.data.address_2"
                      :rules="form.rules.address_2"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      label="City"
                      v-model="form.data.city"
                      :rules="form.rules.city"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="State"
                      v-model="form.data.state"
                      :rules="form.rules.state"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Zipcode"
                      v-model="form.data.zipcode"
                      :rules="form.rules.zipcode"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      label="Phone"
                      v-model="form.data.phone"
                      v-mask="masks.phone"
                      :rules="form.rules.phone"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>

                  <v-radio-group v-model="form.data.phone_type" row>
                    <v-radio
                      v-for="type in catalogs.phone_types"
                      :key="type.value"
                      :label="type.text"
                      :value="type.value"
                    ></v-radio>
                  </v-radio-group>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Email"
                      v-model="form.data.email"
                      :rules="form.rules.email"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-col>

              <!-- Right column -->
              <v-col :cols="rightColumnWidth">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Tax ID"
                      v-model="form.data.tax_id"
                      v-mask="masks.tax_id"
                      :rules="form.rules.tax_id"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      label="Comission"
                      v-model="form.data.commission"
                      :rules="form.rules.commission"
                      type="number"
                      dense
                      hide-details="auto"
                      outlined
                    />
                  </v-col>
                  <v-radio-group v-model="form.data.commission_type" row>
                    <v-radio
                      v-for="type in catalogs.comission_types"
                      :key="type.value"
                      :label="type.text"
                      :value="type.value"
                    ></v-radio>
                  </v-radio-group>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      label="Type"
                      v-model="form.data.type"
                      :rules="form.rules.type"
                      :items="catalogs.affiliate_types"
                      outlined
                      dense
                      hide-details="auto"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      label="Status"
                      v-model="form.data.status"
                      :rules="form.rules.status"
                      :items="catalogs.statuses"
                      outlined
                      dense
                      hide-details="auto"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="text-center">
                <v-btn color="primary" :disabled="!form.valid" v-text="'Save changes'" @click="submit"></v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { PHONE_MASK, TAX_ID_MASK, EMAIL_PATTERN } from '@/global/consts.js';
import { processPhoneNumber } from '@/global/helpers.js';

const AFFILIATE_TYPES = [
  { text: 'Marketing Agency', value: 'Marketing Agency' },
  { text: 'Influencer', value: 'Influencer' },
  { text: 'IMO', value: 'IMO' },
  { text: 'Agency', value: 'Agency' },
  { text: 'Agent', value: 'Agent' },
  { text: 'P&C Agent', value: 'P&C Agent' },
  { text: 'Insurance Company', value: 'Insurance Company' },
];
const PHONE_TYPES = [{ text: 'Cell', value: 'cell' }, { text: 'Phone', value: 'phone' }];
const COMISSION_TYPES = [{ text: '%', value: 'percent' }, { text: '$', value: 'fix' }];
const AFFILIATE_STATUSES = [{ text: 'Active', value: 1 }, { text: 'Inactive', value: 0 }]

export default {
  name: 'AdminAffiliatesEdit',
  data: () => ({
    loading: false,
    affiliateId: null,
    form: {
      disabled: false,
      isPhoneEdit: false,
      valid: true,
      data: {
        name: '',
        first_name: '',
        last_name: '',
        company: '',
        address_1: '',
        address_2: "",
        city: '',
        state: '',
        zipcode: '',
        phone: '',
        phone_type: PHONE_TYPES[0].value, 
        email: '',
        tax_id: '',
        commission: '',
        commission_type: COMISSION_TYPES[0].value,
        type: AFFILIATE_TYPES[0].value,
        status: AFFILIATE_STATUSES[0].value,
      },
      rules: {
        name: [v => !!v || 'Name is required!'],
        first_name: [v => !!v || 'First name is required!'],
        last_name: [v => !!v || 'Last name is required!'],
        company: [],
        address_1: [v => !!v || 'Address is required!'],
        address_2: [],
        city: [v => !!v || 'City is required!'],
        state: [v => !!v || 'State is required!'],
        zipcode: [v => !!v || 'Zip code is required!'],
        phone: [v => !!v || 'Phone is required!'],
        phone_type: [v => !!v || 'Phone type is required!'], 
        email: [v => !!v || 'Email is required!', v => EMAIL_PATTERN.test(v) || 'Invalid e-mail.'],
        tax_id: [],
        commission: [v => !!v || 'Comission is required!'],
        commission_type: [v => !!v || 'Comission type is required!'],
        type: [v => !!v || 'Type is required!'],
        status: [v => v !== null || 'Status is required!'],
      },
    },
    catalogs: {
      affiliate_types: AFFILIATE_TYPES,
      phone_types: PHONE_TYPES,
      comission_types: COMISSION_TYPES,
      statuses: AFFILIATE_STATUSES,
    },
    masks: {
      phone: PHONE_MASK,
      tax_id: TAX_ID_MASK,
    }
  }),
  computed: {
    leftColumnWidth() {
      const { sm, xs } = this.$vuetify.breakpoint;
      return sm ? 6 : xs ? 12 : 5;
    },
    rightColumnWidth() {
      const { sm, xs } = this.$vuetify.breakpoint;
      return sm ? 6 : xs ? 12 : 3;
    },
  },
  mounted () {
    this.affiliateId = this.$route.params.affiliate_id;

    if (this.affiliateId) {
      this.getAffiliateDetails();
    }
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      const method = (this.affiliateId ? 'put' : 'post');
      const url = (this.affiliateId ? 'affiliates/' + this.affiliateId + '?' : 'affiliates');
      const data = { ...this.form.data, phone: processPhoneNumber(this.form.data.phone) };

      this.$http({ method, url, data })
        .then(() => this.$router.push({ name: 'system-admin-affiliates' }))
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was a problem saving the affiliate', 'error')
        })
        .finally(() => this.loading = false);
    },
    getAffiliateDetails() {
      this.loading = true;

      let qParams = [];

      this.$http.get('affiliates/' + this.affiliateId + '?' + qParams.join('&'))
        .then(response => {
          this.form.data = { ...response.data };
          this.loading = false;
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Error loading affiliate info', 'error')
        })
    },
    closeCreate () {
      this.$router.push({name: 'system-admin-affiliates'})
    },
  }
}
</script>